import { P00039DataRxTxIndex } from '../../P00039Sync';
import { Pool } from '../../../../../../apis/pool.api';
import { IProduct } from '../../../IProduct';

export function P0003603FunctionReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.Robot_Controle,
    'rbCResetUsine',
    1,
    null,
    productClass,
  );
}
